var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#0F0F35"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.442 29.395c2.015 1.152 2.015 4.058 0 5.21l-18.954 10.83c-2 1.143-4.488-.301-4.488-2.605V21.17c0-2.304 2.488-3.748 4.488-2.605l18.954 10.83Z",
    fill: "#EFEFFA"
  })));
};
export default SvgPlayButton;